import React from 'react';
import { motion } from 'framer-motion';
import { darken } from 'polished';
import { RefreshIcon } from './Banner.icons';
import WhatsAppIcon from '../../assets/icons/whatsapp.svg';
import * as styles from './Banner.module.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

type InfoBannerProps = {
  banner: {
    title: string;
    active: boolean;
    label: string;
    showNavigation: boolean;
    fixed: boolean;
    centered: boolean;
    auto: boolean;
    autoInterval: number;
    randomStart: boolean;
    backgroundColor: {
      hex: string;
    };
    items: Quote[] | Status[];
  };
};

type Quote = {
  image: {
    url: string;
  };
  imageLink: string;
  quote: string;
  __typename: 'DatoCmsMotivationalQuote';
};

type Status = {
  text: string;
  __typename: 'DatoCmsStatusUpdate';
};

export default function InfoBanner({ banner }: InfoBannerProps) {
  const { title, active, label, items, showNavigation, auto, autoInterval, fixed } = banner;
  const sliderRef = React.useRef<Slider>(null);

  const bgColor = banner.backgroundColor?.hex ?? '#fc99c4';

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: auto,
    autoplaySpeed: (autoInterval ?? 4) * 1000,
    fade: true,
    waitForAnimate: true,
    cssEase: 'linear',
  };

  const list = title.toLowerCase().includes('quotes')
    ? [...items].sort(() => Math.random() - 0.5).slice(0, 16)
    : items;

  if (!active) return null;

  return (
    <div
      className={`banner ${styles.infoBanner} ${fixed && styles.sticky}`}
      style={{ backgroundColor: bgColor }}
    >
      <div className={`banner-wrap navigation-container ${styles.infoBannerWrap}`}>
        <div className={styles.innerWrap}>
          {label && (
            <div className={`content-wrap-01 ${styles.contentWrap}`}>
              <div className={styles.label}>{label}</div>
            </div>
          )}
          <div style={{ width: '80%', position: 'relative' }}>
            <Slider ref={sliderRef} {...settings}>
              {list.map((item, index) => (
                <div className="container" key={index}>
                  {item.__typename === 'DatoCmsMotivationalQuote' ? (
                    <div key={item.quote} className={styles.infoBannerText}>
                      {item.image?.url &&
                        (item.imageLink ? (
                          <a
                            href={item.imageLink}
                            target={item.imageLink.includes('http') ? '_blank' : '_self'}
                            rel="noopener noreferrer"
                          >
                            <img
                              src={item.image.url}
                              style={{
                                borderColor: darken(0.35, bgColor),
                              }}
                              alt="quote"
                            />
                          </a>
                        ) : (
                          <img src={item.image.url} alt="quote" />
                        ))}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.quote,
                        }}
                      />
                    </div>
                  ) : (
                    <div key={item.text} className={styles.infoBannerText}>
                      {/* TODO: Fix this */}
                      {title.includes('Whatsapp') && (
                        <img
                          src={WhatsAppIcon}
                          alt="whatsapp"
                          style={{
                            border: 'none',
                            width: '35px',
                            height: '35px',
                            minWidth: '35px',
                          }}
                        />
                      )}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.text,
                        }}
                      />
                    </div>
                  )}
                </div>
              ))}
            </Slider>
          </div>
          {showNavigation && (
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => {
                sliderRef.current?.slickNext();
              }}
              className={styles.refreshButton}
              style={{
                backgroundColor: darken(0.1, bgColor),
                justifySelf: 'flex-end',
              }}
            >
              <RefreshIcon />
            </motion.button>
          )}
        </div>
      </div>
    </div>
  );
}
